import React from 'react';
import { CommonDeleteModal } from 'components';
import { useDeleteModal } from './useDeleteModal';

interface DeleteModal {
  openModal: boolean;
  isSubTable: boolean | undefined;
  recordId: string | undefined;
  onDeleteModalClose: (id?: string) => void;
}

export const DeleteModal = (props: DeleteModal) => {
  const { openModal, onDeleteModalClose, recordId, isSubTable } = props;
  const { onRemoveConfirm, isLoading } = useDeleteModal(onDeleteModalClose, isSubTable);
  return (
    <CommonDeleteModal
      onCancel={() => onDeleteModalClose()}
      open={openModal}
      isLoading={isLoading}
      onOk={() => onRemoveConfirm(recordId)}
      onClose={() => onDeleteModalClose()}
      title={'Delete Supplier Offer Item'}
      message={
        isSubTable
          ? 'Are you sure you want to delete the Supplier Offer Item?'
          : 'Deleting this Supplier Offer Item will also remove all related alternatives and substitutes that were created from it. Are you sure you want to delete the Supplier Offer Item?'
      }
    />
  );
};
